module.exports = __webpack_public_path__ + "static/media/Romantic-Couple-Script.5d51712a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Romantic-Couple-Script.woff
// module id = 2433
// module chunks = 49